import { type IAccountView, LocationScope } from '@shared/services';

export const accountHasLocationChoices = (account: IAccountView): boolean => {
  return account.locationScope === LocationScope.LIST && account.locations.length > 1;
};
